// news.js
'use strict';

import InfiniteScroll from 'infinite-scroll';
import resizer from './image-resize';

class News {
    constructor() {
        this.pagination = document.querySelector('[js-hook-product-pagination]');
        this.init();
    }

    resizePhotos() {
        resizer.process(".latest-news-inner img.auto-crop", { centerCrop: 1, ratio: 2, maxHeight: 256 });
        resizer.process(".latest-news-inner img:not('.auto-crop')");
    }

    init() {
        const news = document.querySelector('.latest-news');
        const initScroll = new InfiniteScroll(news, {
            path: 'a[rel="next"]',
            append: '.news-container',
            history: false,
            status: '.ajax-loader',
            hideNav: this.pagination,
            scrollThreshold: 400,
            debug: process.env.NODE_ENV === 'development',
        });

        initScroll.on('load', () => {
            this.resizePhotos();
        });
    }
}

export default News;
